import { CarRiskData } from './car-risk-data';
import { HomeRiskData } from './home-risk-data';
import { IntegralRiskData } from './integral-risk-data.model';
import { PersonalsAccidentsRiskData } from './personals-accidents-risk-data';

export class OpportunityQuoteRequest {
  firstName: string;
  lastName: string;
  documentNumber: string;
  documentType: string;
  riskData?: PersonalsAccidentsRiskData | HomeRiskData | CarRiskData | IntegralRiskData;
  productKey?: string;
  jobNumber: string;
  policyPeriodId: string;
  currency?: string;
  term?: string;
  paymentMethod?: string;
  paymentFee: string | number;
  opportunitiesId: number;
  franchiseValue?: number;
  franchiseType?: string;
  premium?: number;
  totalCost?: number;
  paymentType?: string;
  quoteDate?: Date;
}
